<span hidden>
  {{'clear' | translate}}
</span>
<router-outlet></router-outlet>
